import { faChevronDown } from "@jewlr/pro-regular-svg-icons/faChevronDown"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { Suspense, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"

import { setDesktopSubmenu, activateSubmenu } from "app-store-v2/app/actions"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { retry } from "helpers/application"
import useNavigation from "helpers/use-navigation"
import { cn } from "styles/utils"

const DesktopDropdown = loadable(() => retry(() => import("./dropdown")), {
  ssr: false,
})

const MenuItem = ({ index, item }) => {
  const dispatch = useDispatch()
  const showSubmenu = useSelector((state) => state.menu.showSubmenu)
  const submenu = useSelector((state) => state.menu.desktopSubmenu)
  const isOpened = showSubmenu && item.name === submenu.name
  const keyboardProps = useNavigation({ direction: "horizontal" })
  const isLink = !!item.url

  const updateSubmenu = useCallback((cat) => {
    dispatch(activateSubmenu())
    dispatch(setDesktopSubmenu(cat))
  }, [])

  return (
    <li key={index} role="none">
      <Button
        asChild={isLink}
        className={cn(
          "h-(--desktop-header-height) text-14 leading-16 p-6 uppercase text-black",
          isOpened &&
            "text-primary after:border-b-grey-20 after:z-9 before:absolute before:-bottom-1 before:z-10 before:block before:size-0 before:border-8 before:border-b-white before:border-l-transparent before:border-r-transparent before:border-t-transparent after:absolute after:bottom-0 after:block after:size-0 after:border-8 after:border-l-transparent after:border-r-transparent after:border-t-transparent",
          item.style?.className
        )}
        data-cy={
          isLink
            ? `header-menu-link-desktop-${index}-${item.name}`
            : `header-menu-top-level-${item.name}-desktop`
        }
        data-lc="menu"
        id={item.name}
        onClick={() => {
          if (!isLink) {
            updateSubmenu(item)
          }
        }}
        onMouseEnter={() => updateSubmenu(isLink ? "" : item)}
        role="menuitem"
        tabIndex={
          (showSubmenu && submenu.name ? isOpened : index === 0) ? 0 : -1
        }
        {...(!isLink && {
          "aria-controls": "nav_dropdown_menu",
          "aria-expanded": isOpened,
          "aria-haspopup": true,
        })}
        {...keyboardProps}
      >
        {isLink ? (
          item.external ? (
            <a href={item.url} rel="noopener noreferrer" target="_blank">
              {item.name}
            </a>
          ) : (
            <Link to={item.url}>{item.name}</Link>
          )
        ) : (
          <>
            {item.name}
            <FontAwesomeIcon
              className={cn(
                "text-8 ml-4",
                isOpened ? "text-primary" : "text-grey-55"
              )}
              icon={faChevronDown}
            />
          </>
        )}
      </Button>
      {typeof window !== "undefined" && (
        <Suspense fallback={<div />}>
          <DesktopDropdown showSubmenu={isOpened} />
        </Suspense>
      )}
    </li>
  )
}

MenuItem.propTypes = {
  index: PropTypes.number,
  item: PropTypes.object,
}

export default MenuItem
